import React, { Component, forwardRef } from 'react';
import { animateScroll as scroll } from 'react-scroll';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export function withScrollTopOnMount(WrappedComponent) {
  class WithScrollOnStop extends Component {
    componentDidMount() {
      setImmediate(() => {
        scroll.scrollToTop();
      });
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  WithScrollOnStop.displayName = `WithScrollOnStop(${getDisplayName(WrappedComponent)})`;
  return WithScrollOnStop;
}

export function withForwardRef(WrappedComponent) {
  const WithForwardRef = forwardRef((props, ref) => (
    <WrappedComponent {...props} forwardRef={ref} />
  ));
  WithForwardRef.displayName = `WithForwardRef(${getDisplayName(WrappedComponent)})`;
  return WithForwardRef;
}
